import Ad from 'src/components/ads/Ad';
import StaticImage from 'src/components/images/StaticImage';
import FilmQuizChairSvg from 'src/components/svg/FilmQuizChairSvg';
import theme from 'src/components/themes/DefaultTheme';
import AdWrapper from 'src/lib/contexts/AdContext';
import styled from 'src/lib/styles/css';

//#region [Props]
type IntroProps = {
	doStartQuiz: () => void;
};
//#endregion

//#region [Component]
export default function Intro({ doStartQuiz }: IntroProps) {

	let today = new Date();
	let easter = GetEasterDate(today.getFullYear());
	let daysToEaster = Math.floor((easter.getTime() - today.getTime()) / (1000 * 3600 * 24));
	let useEasterImage = false;
	if (daysToEaster >= -2 && daysToEaster <= 14) {
		useEasterImage = true;
	}

	return <>
		<AdWrapper ads={ADS}>
			<SAd targetId='FW_topp_quiz' removeIfNoAd supportsFixedAd />
		</AdWrapper>
		<SIntro onClick={doStartQuiz}>
			{useEasterImage && <SEasterImage image='/FilmquizPaaske.png' alt="Filmweb Påskequiz!" width={600} height={884}/>}
			{!useEasterImage && <FilmQuizChairSvg />}
			<SHeader>FILMQUIZ</SHeader>

			<div>Velkommen til Filmwebs filmquiz!</div>
			<div>Svar på så mange spørsmål du klarer. </div>
			<div>Ved 3 gale svar avsluttes quizen.</div>
		</SIntro>
		<SStartQuizButton onClick={doStartQuiz}>Start quiz</SStartQuizButton>
	</>;
}
//#endregion

//#region [Styles]


const SIntro = styled.div`
	cursor: pointer;
	background: ${theme.palette.lilla4};
	border-radius: 20px 20px 0px 0px;

	padding: 30px 10px;
`;

const SStartQuizButton = styled.button`
	cursor: pointer;
	color: var(--textcolor);
	background: ${theme.mainColor};
	border-radius: 0px 0px 20px 20px;

	padding: 10px;
	font-size: 24px;
	font-weight: bold;
	border: none;
	margin: 0;
	width: 100%;
`;

const SHeader = styled.h1`
	margin-top: 10px;
	margin-bottom: 20px;

	font-size: 48px;
	font-weight: bold;
`;

const SAd = styled(Ad)`
	margin-top: 10px;
	margin-bottom: 30px;
`;

const SEasterImage = styled(StaticImage)`
	width: 120px;
	height: auto;
	margin: 0 auto;
`;
//#endregion

const ADS = [
	{ auId: '00000000000eb992', auW: '2000', auH: '300', targetId: 'FW_topp_quiz' }
];

function GetEasterDate(Y: number) {
	var C = Math.floor(Y / 100);
	var N = Y - 19 * Math.floor(Y / 19);
	var K = Math.floor((C - 17) / 25);
	var I = C - Math.floor(C / 4) - Math.floor((C - K) / 3) + 19 * N + 15;
	I = I - 30 * Math.floor((I / 30));
	I = I - Math.floor(I / 28) * (1 - Math.floor(I / 28) * Math.floor(29 / (I + 1)) * Math.floor((21 - N) / 11));
	var J = Y + Math.floor(Y / 4) + I + 2 - C + Math.floor(C / 4);
	J = J - 7 * Math.floor(J / 7);
	var L = I - J;
	var M = 3 + Math.floor((L + 40) / 44);
	var D = L + 28 - 31 * Math.floor(M / 4);

	return new Date(Y, M - 1, D);
}